"use strict";

exports.__esModule = true;
exports.getTabsListDimensions = exports.defaultTabsListDimensions = exports.RenderTabContent = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TAB_CONTENT_PADDING = 20;
var VERTICAL = "vertical";
var RenderTabContent = exports.RenderTabContent = function RenderTabContent(_ref) {
  var child = _ref.child,
    index = _ref.index,
    props = _ref.props,
    tabsListDimensions = _ref.tabsListDimensions,
    _ref$editableTabsWidg = _ref.editableTabsWidget,
    editableTabsWidget = _ref$editableTabsWidg === void 0 ? false : _ref$editableTabsWidg;
  var render = props.render,
    width = props.width,
    height = props.height,
    orientation = props.orientation;
  var childWidth = getChildWidth(width, orientation, tabsListDimensions);
  var childHeight = getChildHeight(height, orientation, tabsListDimensions);
  var childX = getChildX(editableTabsWidget, orientation);
  var childY = getChildY(editableTabsWidget, orientation);
  return /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    id: index,
    key: index,
    title: child.props.title,
    "data-testid": "Tab-" + child.props.title,
    panel: render(Object.assign({}, child, {
      props: Object.assign({}, child.props, {
        x: childX,
        y: childY,
        width: childWidth,
        height: childHeight
      })
    }), index)
  });
};
var getTabsListDimensions = exports.getTabsListDimensions = function getTabsListDimensions(currentRef) {
  var el = currentRef == null ? void 0 : currentRef.tablistElement;
  return el ? {
    width: el.offsetWidth,
    height: el.offsetHeight
  } : defaultTabsListDimensions;
};
var defaultTabsListDimensions = exports.defaultTabsListDimensions = {
  height: 0,
  width: 0
};
var getChildWidth = function getChildWidth(width, orientation, tabsListDimensions) {
  if (orientation === VERTICAL) {
    // Subtracting width of tabs + TAB_CONTENT_PADDING (px) padding from width of widget
    return width - (TAB_CONTENT_PADDING + tabsListDimensions.width);
  }
  return width;
};
var getChildHeight = function getChildHeight(height, orientation, tabsListDimensions) {
  if (orientation !== VERTICAL) {
    // Subtracting height of tabs + TAB_CONTENT_PADDING (px) padding from height of widget
    return height - (TAB_CONTENT_PADDING + tabsListDimensions.height);
  }
  return height;
};
var getChildX = function getChildX(editableTabsWidget, orientation) {
  if (!editableTabsWidget) {
    if (orientation === VERTICAL) {
      return 100;
    }
  }
  return 0;
};
var getChildY = function getChildY(editableTabsWidget, orientation) {
  if (!editableTabsWidget) {
    if (orientation !== VERTICAL) {
      return 100;
    }
  }
  return 0;
};